import {
    getCurrentEnterpriseId,
    getCurrentProfileIdOrNull,
    getCurrentUserOrNull,
    getSessionId,
} from '@mews-commander/core';
import { getEnterpriseName, getEnterpriseUniqueName } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { getCurrentEnterpriseCountryCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { ApplicationState } from '@mews-commander/types';
import { getCurrentUrl } from '@mews-commander/utils';
import { Application, MewsTeam } from '@mews/enums';
import { isAppVisible } from '@mews/std';
import { normalizeUrl } from '../modules/app/actions/newRelic';
import { getPlatformEnvironment, getVersion } from '../modules/app/reducers/configuration';

interface CustomProperties {
    owner?: MewsTeam;
    routePath?: string;
    url?: string;
}

export const setNewRelicCustomAttributes = (state: ApplicationState, customProperties: CustomProperties) => {
    if (window.newrelic == null) {
        return;
    }

    const sessionId = getSessionId();
    const userId = getCurrentUserOrNull()?.id ?? null;
    const profileId = getCurrentProfileIdOrNull();
    const enterpriseId = getCurrentEnterpriseId();
    const enterpriseName = getEnterpriseName(state, { enterpriseId });
    const enterpriseUniqueName = getEnterpriseUniqueName(state, { enterpriseId });
    const countryCode = getCurrentEnterpriseCountryCode(state);
    const url = customProperties.url ?? getCurrentUrl();
    const normalizedUrl = normalizeUrl(url);
    const appVisible = isAppVisible();
    const environment = getPlatformEnvironment();
    const appVersion = getVersion();

    window.newrelic.setCustomAttribute('ownerTeam', customProperties.owner ?? null);
    window.newrelic.setCustomAttribute('routePath', customProperties.routePath ?? null);
    window.newrelic.setCustomAttribute('sessionId', sessionId, true);
    window.newrelic.setCustomAttribute('userId', userId, true);
    window.newrelic.setCustomAttribute('profileId', profileId, true);
    window.newrelic.setCustomAttribute('enterpriseId', enterpriseId, true);
    window.newrelic.setCustomAttribute('enterpriseName', enterpriseName, true);
    window.newrelic.setCustomAttribute('enterpriseUniqueName', enterpriseUniqueName ?? null, true);
    window.newrelic.setCustomAttribute('countryCode', countryCode as string, true);
    window.newrelic.setCustomAttribute('url', url);
    window.newrelic.setCustomAttribute('normalizedUrl', normalizedUrl);
    window.newrelic.setCustomAttribute('environment', environment, true);
    window.newrelic.setCustomAttribute('isAppVisible', appVisible, true);
    window.newrelic.setCustomAttribute('appName', Application.Commander, true);
    window.newrelic.setCustomAttribute('appVersion', appVersion, true);
};
